import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import i18n from 'i18next';
import { LANGUAGES, LEGAL_COMPLIANCE_ADMIN_TYPE, SUB_ADMIN_TYPES } from "assets/constants";

const normalizeLang = (value) => {
    const lang = (value || "").toLowerCase().split("-")[0];
    return LANGUAGES.includes(lang) ? lang : "sp";
};

const ProtectedRoute = ({ isAdmin = false, isSubAdmin = false, allowedTypes }) => {
    const { adminUser } = useSelector((store) => store.admin);
    const lang = normalizeLang(i18n.language);

    const resolvedAllowedTypes =
        allowedTypes ??
        (isAdmin ? ["owner"] : isSubAdmin ? SUB_ADMIN_TYPES : null);

    const redirectToPath = (path) => {
        window.location.replace(path)
    };

    const getDeniedPath = () => {
        if (adminUser?.type === LEGAL_COMPLIANCE_ADMIN_TYPE) {
            return `/${lang}/admin/legal-compliance`;
        }

        if (SUB_ADMIN_TYPES.includes(adminUser?.type)) {
            return `/${lang}/sub-admin/dashboard`;
        }

        return `/${lang}/admin-login`;
    };

    if (!adminUser) {
        return redirectToPath(`/${lang}/admin-login`);
    }

    if (resolvedAllowedTypes && !resolvedAllowedTypes.includes(adminUser?.type)) {
        return redirectToPath(getDeniedPath());
    }

    return <Outlet />;
}

export default ProtectedRoute;
